/** Translated labels for @motolynk/ui blocks whose built-in defaults are English. */

import { useTranslation } from "@motolynk/i18n";

export function useUiLabels() {
  const { t } = useTranslation("common");
  return {
    table: {
      previous: t("table.previous"),
      next: t("table.next"),
      pageOf: (page: number, pages: number, total: number) =>
        t("table.pageOf", { page, pages, total }),
      emptyTitle: t("table.empty"),
    },
    clearFilters: t("filters.clear"),
    retry: t("actions.retry"),
    cancel: t("actions.cancel"),
    confirm: t("actions.confirm"),
    close: t("actions.close"),
    loading: t("app.loading"),
  };
}

/** Toolbar labels of the rich-text editor (`RichTextEditor` in @motolynk/ui). */
export function useRichTextLabels() {
  const { t } = useTranslation("common");
  return {
    toolbar: t("richText.toolbar"),
    bold: t("richText.bold"),
    italic: t("richText.italic"),
    underline: t("richText.underline"),
    strike: t("richText.strike"),
    heading2: t("richText.heading2"),
    heading3: t("richText.heading3"),
    bulletList: t("richText.bulletList"),
    orderedList: t("richText.orderedList"),
    quote: t("richText.quote"),
    link: t("richText.link"),
    unlink: t("richText.unlink"),
    undo: t("richText.undo"),
    redo: t("richText.redo"),
    linkUrl: t("richText.linkUrl"),
    applyLink: t("richText.applyLink"),
    cancel: t("richText.cancel"),
  };
}
